const portMapStyles = {
  port: {
    weight: 8,
    color: '#2E93FA',
    dashArray: '',
    opacity: 0.7,
    fillOpacity: 0.15,
  },
  berth: {
    weight: 2,
    color: '#22a30e',
    dashArray: '',
    opacity: 0.7,
    fillOpacity: 0.2,
  },
  shipyard: {
    weight: 3,
    color: '#ffe700',
    dashArray: '',
    opacity: 0.7,
    fillOpacity: 0.2,
  },
  anchorage: {
    weight: 3,
    color: '#bd0000',
    dashArray: '',
    opacity: 0.7,
    fillOpacity: 0.2,
  }
};

const inareaMapStyles = {
  port: {
    weight: 4,
    color: '#2E93FA',
    dashArray: '',
    opacity: 0.2,
    fillOpacity: 0.1,
  },
  berth: {
    weight: 4,
    color: '#22a30e',
    dashArray: '',
    opacity: 0.2,
    fillOpacity: 0.2,
  },
  shipyard: {
    weight: 4,
    color: '#ffe700',
    dashArray: '',
    opacity: 0.2,
    fillOpacity: 0.2,
  },
  anchorage: {
    weight: 4,
    color: '#bd0000',
    dashArray: '',
    opacity: 0.2,
    fillOpacity: 0.2,
  },
};

const regionList = [
  {
    region_id: "EAUSSIE",
    region_name: "Eastern Australia",
  },
  {
    region_id: "SOUTHERNAFRICA",
    region_name: "Southern Africa",
  },
  {
    region_id: "ECSA",
    region_name: "East Coast South America",
  },
  {
    region_id: "NCSA",
    region_name: "North Coast South America",
  },
  {
    region_id: "BALTIC",
    region_name: "Baltic",
  },
  {
    region_id: "WCSA",
    region_name: "West Coast South America",
  },
  {
    region_id: "ECCA",
    region_name: "East Coast Central America",
  },
  {
    region_id: "EASTAFRICA",
    region_name: "East Africa",
  },
  {
    region_id: "WESTMED",
    region_name: "Western Mediterranean",
  },
  {
    region_id: "NWAFRICA",
    region_name: "North Western Africa",
  },
  {
    region_id: "WCINDIA",
    region_name: "West Coast India",
  },
  {
    region_id: "ECINDIA",
    region_name: "East Coast India",
  },
  {
    region_id: "WAUSSIE",
    region_name: "Western Australia",
  },
  {
    region_id: "SEA",
    region_name: "South East Asia",
  },
  {
    region_id: "REDSEA",
    region_name: "Red Sea",
  },
  {
    region_id: "AG",
    region_name: "Arabian Gulf",
  },
  {
    region_id: "BLACKSEA",
    region_name: "Black Sea",
  },
  {
    region_id: "CARRIBEAN",
    region_name: "Carribean",
  },
  {
    region_id: "USEC",
    region_name: "US East Coast",
  },
  {
    region_id: "EASTMED",
    region_name: "Eastern Mediterranean",
  },
  {
    region_id: "FAREAST",
    region_name: "Far East",
  },
  {
    region_id: "USG",
    region_name: "US Gulf",
  },
  {
    region_id: "WCCA",
    region_name: "West Coast Central America",
  },
  {
    region_id: "USWC",
    region_name: "US West Coast",
  },
  {
    region_id: "CONT",
    region_name: "Continent",
  }
];

const countryList = [
  {
    country_name: "United Arab Emirates",
    country_code: "AE"
  },
  {
    country_name: "Antigua and Barbuda",
    country_code: "AG"
  },
  {
    country_name: "Angola",
    country_code: "AO"
  },
  {
    country_name: "Argentina",
    country_code: "AR"
  },
  {
    country_name: "Australia",
    country_code: "AU"
  },
  {
    country_name: "Aruba",
    country_code: "AW"
  },
  {
    country_name: "Barbados",
    country_code: "BB"
  },
  {
    country_name: "Bangladesh",
    country_code: "BD"
  },
  {
    country_name: "Belgium",
    country_code: "BE"
  },
  {
    country_name: "Bulgaria",
    country_code: "BG"
  },
  {
    country_name: "Bahrain",
    country_code: "BH"
  },
  {
    country_name: "Brunei Darussalam",
    country_code: "BN"
  },
  {
    country_name: "Bonaire, Sint Eustatius and Saba",
    country_code: "BQ"
  },
  {
    country_name: "Brazil",
    country_code: "BR"
  },
  {
    country_name: "Bahamas",
    country_code: "BS"
  },
  {
    country_name: "Canada",
    country_code: "CA"
  },
  {
    country_name: "Chile",
    country_code: "CL"
  },
  {
    country_name: "Cameroon",
    country_code: "CM"
  },
  {
    country_name: "China",
    country_code: "CN"
  },
  {
    country_name: "Colombia",
    country_code: "CO"
  },
  {
    country_name: "Costa Rica",
    country_code: "CR"
  },
  {
    country_name: "Cuba",
    country_code: "CU"
  },
  {
    country_name: "Cyprus",
    country_code: "CY"
  },
  {
    country_name: "Germany",
    country_code: "DE"
  },
  {
    country_name: "Denmark",
    country_code: "DK"
  },
  {
    country_name: "Dominican Republic",
    country_code: "DO"
  },
  {
    country_name: "Algeria",
    country_code: "DZ"
  },
  {
    country_name: "Ecuador",
    country_code: "EC"
  },
  {
    country_name: "Estonia",
    country_code: "EE"
  },
  {
    country_name: "Egypt",
    country_code: "EG"
  },
  {
    country_name: "Spain",
    country_code: "ES"
  },
  {
    country_name: "Finland",
    country_code: "FI"
  },
  {
    country_name: "France",
    country_code: "FR"
  },
  {
    country_name: "Gabon",
    country_code: "GA"
  },
  {
    country_name: "United Kingdom",
    country_code: "GB"
  },
  {
    country_name: "Grenada",
    country_code: "GD"
  },
  {
    country_name: "Georgia",
    country_code: "GE"
  },
  {
    country_name: "French Guiana",
    country_code: "GF"
  },
  {
    country_name: "Ghana",
    country_code: "GH"
  },
  {
    country_name: "Gibraltar",
    country_code: "GI"
  },
  {
    country_name: "Guinea",
    country_code: "GN"
  },
  {
    country_name: "Guadeloupe",
    country_code: "GP"
  },
  {
    country_name: "Equatorial Guinea",
    country_code: "GQ"
  },
  {
    country_name: "Greece",
    country_code: "GR"
  },
  {
    country_name: "Guatemala",
    country_code: "GT"
  },
  {
    country_name: "Guyana",
    country_code: "GY"
  },
  {
    country_name: "Hong Kong",
    country_code: "HK"
  },
  {
    country_name: "Honduras",
    country_code: "HN"
  },
  {
    country_name: "Croatia",
    country_code: "HR"
  },
  {
    country_name: "Haiti",
    country_code: "HT"
  },
  {
    country_name: "Indonesia",
    country_code: "ID"
  },
  {
    country_name: "Ireland",
    country_code: "IE"
  },
  {
    country_name: "Israel",
    country_code: "IL"
  },
  {
    country_name: "India",
    country_code: "IN"
  },
  {
    country_name: "Iraq",
    country_code: "IQ"
  },
  {
    country_name: "Iran, Islamic Republic of",
    country_code: "IR"
  },
  {
    country_name: "Italy",
    country_code: "IT"
  },
  {
    country_name: "Jamaica",
    country_code: "JM"
  },
  {
    country_name: "Japan",
    country_code: "JP"
  },
  {
    country_name: "Cambodia",
    country_code: "KH"
  },
  {
    country_name: "Saint Kitts and Nevis",
    country_code: "KN"
  },
  {
    country_name: "Korea, Republic of",
    country_code: "KR"
  },
  {
    country_name: "Kuwait",
    country_code: "KW"
  },
  {
    country_name: "Lebanon",
    country_code: "LB"
  },
  {
    country_name: "Saint Lucia",
    country_code: "LC"
  },
  {
    country_name: "Sri Lanka",
    country_code: "LK"
  },
  {
    country_name: "Liberia",
    country_code: "LR"
  },
  {
    country_name: "Lithuania",
    country_code: "LT"
  },
  {
    country_name: "Latvia",
    country_code: "LV"
  },
  {
    country_name: "Libyan Arab Jamahiriya",
    country_code: "LY"
  },
  {
    country_name: "Morocco",
    country_code: "MA"
  },
  {
    country_name: "Madagascar",
    country_code: "MG"
  },
  {
    country_name: "Myanmar",
    country_code: "MM"
  },
  {
    country_name: "Martinique",
    country_code: "MQ"
  },
  {
    country_name: "Mauritania",
    country_code: "MR"
  },
  {
    country_name: "Malta",
    country_code: "MT"
  },
  {
    country_name: "Mauritius",
    country_code: "MU"
  },
  {
    country_name: "Mexico",
    country_code: "MX"
  },
  {
    country_name: "Malaysia",
    country_code: "MY"
  },
  {
    country_name: "Mozambique",
    country_code: "MZ"
  },
  {
    country_name: "Namibia",
    country_code: "NA"
  },
  {
    country_name: "Nigeria",
    country_code: "NG"
  },
  {
    country_name: "Nicaragua",
    country_code: "NI"
  },
  {
    country_name: "Netherlands",
    country_code: "NL"
  },
  {
    country_name: "Norway",
    country_code: "NO"
  },
  {
    country_name: "New Zealand",
    country_code: "NZ"
  },
  {
    country_name: "Oman",
    country_code: "OM"
  },
  {
    country_name: "Panama",
    country_code: "PA"
  },
  {
    country_name: "Peru",
    country_code: "PE"
  },
  {
    country_name: "Papua New Guinea",
    country_code: "PG"
  },
  {
    country_name: "Philippines",
    country_code: "PH"
  },
  {
    country_name: "Pakistan",
    country_code: "PK"
  },
  {
    country_name: "Poland",
    country_code: "PL"
  },
  {
    country_name: "Portugal",
    country_code: "PT"
  },
  {
    country_name: "Qatar",
    country_code: "QA"
  },
  {
    country_name: "Romania",
    country_code: "RO"
  },
  {
    country_name: "Russian Federation",
    country_code: "RU"
  },
  {
    country_name: "Saudi Arabia",
    country_code: "SA"
  },
  {
    country_name: "Sudan",
    country_code: "SD"
  },
  {
    country_name: "Sweden",
    country_code: "SE"
  },
  {
    country_name: "Singapore",
    country_code: "SG"
  },
  {
    country_name: "Slovenia",
    country_code: "SI"
  },
  {
    country_name: "Senegal",
    country_code: "SN"
  },
  {
    country_name: "Suriname",
    country_code: "SR"
  },
  {
    country_name: "Sint Maarten",
    country_code: "SX"
  },
  {
    country_name: "Syrian Arab Republic",
    country_code: "SY"
  },
  {
    country_name: "Togo",
    country_code: "TG"
  },
  {
    country_name: "Thailand",
    country_code: "TH"
  },
  {
    country_name: "Tunisia",
    country_code: "TN"
  },
  {
    country_name: "Turkey",
    country_code: "TR"
  },
  {
    country_name: "Trinidad and Tobago",
    country_code: "TT"
  },
  {
    country_name: "Taiwan, Province of China",
    country_code: "TW"
  },
  {
    country_name: "Tanzania, United Republic of",
    country_code: "TZ"
  },
  {
    country_name: "Ukraine",
    country_code: "UA"
  },
  {
    country_name: "United States",
    country_code: "US"
  },
  {
    country_name: "Uruguay",
    country_code: "UY"
  },
  {
    country_name: "Venezuela",
    country_code: "VE"
  },
  {
    country_name: "Vietnam",
    country_code: "VN"
  },
  {
    country_name: "Yemen",
    country_code: "YE"
  },
  {
    country_name: "South Africa",
    country_code: "ZA"
  }
]


export {
  regionList,
  countryList,
  portMapStyles,
  inareaMapStyles,
}
